import React from "react";
//#region types
import { SelfInvoiceAmountMismatchWarningProps } from "models/propTypes/selfInvoicePropTypes";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { useFloatingMessages } from "components/common";
import { SnackbarKey } from "notistack";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SelfInvoiceAmountMismatchWarning: React.FC<SelfInvoiceAmountMismatchWarningProps> = (props) => {
  const { interpretedTotalIncludingTax, currentTotalIncludingTax } = props;

  const { enqueueMessage, closeMessage } = useFloatingMessages();
  const [alertKeys, setAlertKeys] = React.useState<SnackbarKey>();

  React.useEffect(() => {
    if (interpretedTotalIncludingTax !== currentTotalIncludingTax) {
      showWarning();
    } else {
      setAlertKeys(undefined);
      closeMessage();
    }
  }, [interpretedTotalIncludingTax, currentTotalIncludingTax]);

  React.useEffect(() => {
    return () => {
      closeMessage();
    };
  }, []);

  const showWarning = () => {
    if (alertKeys) {
      return;
    }

    setTimeout(() => {
      const key = enqueueMessage(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.SelfInvoiceTotalMismatchWarning),
        StyleEnums.DisplayType.Warning,
        false
      );

      setAlertKeys(key);
    });
  };

  return <></>;
};

export default SelfInvoiceAmountMismatchWarning;
